export const hero_constants = {
  title: "AI Solutions Built for",
  texts: ["Computer Vision", "Language Models", "Custom AI Development"],
  description:
    "Powerd by [AI] provides both ready-to-deploy AI models and comprehensive development services for African markets. Start by exploring our collection of computer vision and vision-language models or contact us to build custom solutions tailored to your unique requirements.",
  image:
    "https://res.cloudinary.com/analytics-intelligence/image/upload/v1755204908/powerdbyai/hero-image_rzcnsa.png",
};

export const services_constants = {
  title: "Services We Offer",
  description:
    "From training data to production-ready AI—get everything you need to build, test, and scale.",
  services: [
    {
      id: "data-annotation",
      title: "Data Annotation",
      description:
        "Expert data collection, cleaning, and preparation services to ensure your AI models are trained on high-quality datasets",
      icon: (isActive) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 12C16.5563 12 20.25 9.98528 20.25 7.5C20.25 5.01472 16.5563 3 12 3C7.44365 3 3.75 5.01472 3.75 7.5C3.75 9.98528 7.44365 12 12 12Z"
            stroke={isActive ? "white" : "#222222"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.75 7.5V12C3.75 14.4853 7.44375 16.5 12 16.5C16.5562 16.5 20.25 14.4853 20.25 12V7.5"
            stroke={isActive ? "white" : "#222222"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.75 12V16.5C3.75 18.9853 7.44375 21 12 21C16.5562 21 20.25 18.9853 20.25 16.5V12"
            stroke={isActive ? "white" : "#222222"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: "model-finetuning",
      title: "Model Finetuning",
      description:
        "Specialized model optimization for specific industries and use cases, ensuring maximum accuracy and relevance for your business domain.",
      icon: (isActive) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M3.06641 7.2113L12.0008 12.1013L20.9352 7.2113"
            stroke={isActive ? "white" : "#222222"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.36 2.34376L20.61 6.86063C20.7278 6.92509 20.8261 7.01999 20.8947 7.13542C20.9633 7.25086 20.9997 7.3826 21 7.51688V16.4831C20.9997 16.6174 20.9633 16.7492 20.8947 16.8646C20.8261 16.98 20.7278 17.0749 20.61 17.1394L12.36 21.6563C12.2496 21.7167 12.1258 21.7483 12 21.7483C11.8742 21.7483 11.7504 21.7167 11.64 21.6563L3.39 17.1394C3.2722 17.0749 3.17386 16.98 3.10526 16.8646C3.03666 16.7492 3.0003 16.6174 3 16.4831V7.51688C3.0003 7.3826 3.03666 7.25086 3.10526 7.13542C3.17386 7.01999 3.2722 6.92509 3.39 6.86063L11.64 2.34376C11.7504 2.28336 11.8742 2.25171 12 2.25171C12.1258 2.25171 12.2496 2.28336 12.36 2.34376Z"
            stroke={isActive ? "white" : "#222222"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 12.1022V21.75"
            stroke={isActive ? "white" : "#222222"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: "small-language-model",
      title: "Small Language Model",
      description:
        "Efficient, lightweight language models designed for resource-constrained environments while maintaining high performance and accuracy.",
      icon: (isActive) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M3 12H21"
            stroke={isActive ? "white" : "#222222"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
            stroke={isActive ? "white" : "#222222"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.75 12C15.75 18 12 21 12 21C12 21 8.25 18 8.25 12C8.25 6 12 3 12 3C12 3 15.75 6 15.75 12Z"
            stroke={isActive ? "white" : "#222222"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: "computer-vision",
      title: "Computer Vision Model",
      description:
        "Advanced image recognition and analysis capabilities for object detection, classification, and visual understanding applications.",
      icon: (isActive) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M3.75 16.5V6.75C3.75 6.35218 3.90804 5.97064 4.18934 5.68934C4.47064 5.40804 4.85218 5.25 5.25 5.25H18.75C19.1478 5.25 19.5294 5.40804 19.8107 5.68934C20.092 5.97064 20.25 6.35218 20.25 6.75V16.5"
            stroke={isActive ? "white" : "#222222"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.25 16.5H21.75V18C21.75 18.3978 21.592 18.7794 21.3107 19.0607C21.0294 19.342 20.6478 19.5 20.25 19.5H3.75C3.35218 19.5 2.97064 19.342 2.68934 19.0607C2.40804 18.7794 2.25 18.3978 2.25 18V16.5Z"
            stroke={isActive ? "white" : "#222222"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.5 8.25H10.5"
            stroke={isActive ? "white" : "#222222"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
  ],
};

export const stats_constants = [
  {
    number: "89%",
    description: "Reduction in training time through our deployment.",
  },
  {
    number: "98%",
    description: "Success rate model fine-tuned for African market",
  },
  {
    number: "3X",
    description: "Faster model performance gains",
  },
];

export const platform_constants = {
  title: "What You Can Do With Our Platform",
  description:
    "We specialize in both Computer vision and vision-language model development, enabling cutting-edge, context-aware AI solutions tailored to African data and use cases. ",
  platforms: [
    {
      title: "Model Playground",
      description:
        "Test and explore our models. Run tests, visualize outputs, compare results, and benchmark performance using real-world African data all in one intuitive interface",
      cta: "Try Our Playground",
      link: "/signup",
      image:
        "https://res.cloudinary.com/analytics-intelligence/image/upload/v1755204905/powerdbyai/model-pg_srwlc8.png",
    },
    {
      title: "Community Collaboration",
      description:
        "Connect with Africa's growing AI ecosystem. Share datasets, collaborate on projects, and stay up-to-date with the latest tools and trends in regional AI innovation.",
      cta: "Join Our Community",
      link: "/signup",
      image:
        "https://res.cloudinary.com/analytics-intelligence/image/upload/v1755204895/powerdbyai/community-collab_kz7exm.png",
    },
  ],
};

export const models_constants = {
  title: "Built for Real-World African Impact",
  description:
    "From detecting waste in public areas to verifying food quality and monitoring infrastructure, our models are built for use cases that matter: ",
  features: [
    "Smart agriculture & food safety",
    "Waste management & environmental tracking",
    "Urban planning & infrastructure inspection",
    "Identity verification & object detection",
  ],
  tagLine:
    "Whether you're a developer, researcher, or entrepreneur. Our platform is your launchpad. ",
  CheckIcon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#EDF8FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9457 8.62169L11.5923 16.6834L9.37568 14.315C8.96734 13.93 8.32568 13.9067 7.85901 14.2334C7.40401 14.5717 7.27568 15.1667 7.55568 15.645L10.1807 19.915C10.4373 20.3117 10.8807 20.5567 11.3823 20.5567C11.8607 20.5567 12.3157 20.3117 12.5723 19.915C12.9923 19.3667 21.0073 9.81169 21.0073 9.81169C22.0573 8.73836 20.7857 7.79336 19.9457 8.61002V8.62169Z"
        fill="#0165FE"
      />
    </svg>
  ),
  src: "https://res.cloudinary.com/analytics-intelligence/image/upload/v1755204905/powerdbyai/impact_zog1jt.png",
  alt: "Real-world African AI applications showing agriculture, facial recognition, mobile technology, and various AI implementations",
};

export const why_constants = {
  title: "Why Choose Powerd by AI",
  description:
    "We specialize in both Computer vision and vision-language model development, enabling cutting-edge, context-aware AI solutions tailored to African data and use cases. ",
  reasons: [
    {
      title: "Local Expertise, Global Standards",
      features: [
        "Deep understanding of African market dynamics",
        "Cultural sensitivity in AI model development",
        "Compliance with local data protection regulations",
        "Support for indigenous languages and contexts",
      ],
      image:
        "https://res.cloudinary.com/analytics-intelligence/image/upload/v1755204903/powerdbyai/LEGS_zy3uqy.png",
    },
    {
      title: "Proven Track Record",
      features: [
        "Successfully deployed solutions",
        "95%+ client satisfaction rate",
        "Certified data scientists and ML engineers",
        "ISO 27001 certified security practices",
      ],
      image:
        "https://res.cloudinary.com/analytics-intelligence/image/upload/v1755204909/powerdbyai/PTR_p2p0bs.png",
    },
    {
      title: "End-to-End Support",
      features: [
        "Consultation and strategy development",
        "Data collection and preparation",
        "Model development and testing",
        "Deployment and ongoing maintenance",
        "Training and knowledge transfer",
      ],
      image:
        "https://res.cloudinary.com/analytics-intelligence/image/upload/v1755204903/powerdbyai/E2ES_cgmotk.png",
    },
  ],
  CheckIcon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#EDF8FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9457 8.62169L11.5923 16.6834L9.37568 14.315C8.96734 13.93 8.32568 13.9067 7.85901 14.2334C7.40401 14.5717 7.27568 15.1667 7.55568 15.645L10.1807 19.915C10.4373 20.3117 10.8807 20.5567 11.3823 20.5567C11.8607 20.5567 12.3157 20.3117 12.5723 19.915C12.9923 19.3667 21.0073 9.81169 21.0073 9.81169C22.0573 8.73836 20.7857 7.79336 19.9457 8.61002V8.62169Z"
        fill="#0165FE"
      />
    </svg>
  ),
};

export const faq_constants = {
  title: "Frequently Asked Questions",
  description:
    "Everything you need to know about building, training, and deploying Afrocentric computer vision solutions",
  faqData: [
    {
      question: "Why focus on Africa-specific solutions?",
      answer:
        "Why not! Many global AI models overlook the unique environments and contexts of Africa. Our platform fills that gap by ensuring models is trained and validated on regionally relevant data.",
    },
    {
      question: "Are there pre-annotated datasets available?",
      answer:
        "Yes. We offer a growing repository of annotated images reflecting African environments—urban areas, rural farms, local markets, and more.",
    },
    {
      question: "Who can use this platform?",
      answer:
        "Whether you're a developer, researcher, entrepreneur, or student, our platform is built for anyone working on computer vision projects with a focus on African use cases.",
    },
    {
      question: "What real-world problems does this platform help solve?",
      answer: `Our platform supports applications in: <br />
· Smart agriculture and food safety <br />
· Smart healthcare practices with computer vision <br />
· Models that aid ease in lifestyle and way of living`,
    },
  ],
  PlusIcon: ({ className }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      className={className}
    >
      <path
        d="M11.5 22.5C17.299 22.5 22 17.799 22 12C22 6.20101 17.299 1.5 11.5 1.5C5.70101 1.5 1 6.20101 1 12C1 17.799 5.70101 22.5 11.5 22.5Z"
        stroke="#130F40"
        strokeOpacity="0.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 12H16"
        stroke="#130F40"
        strokeOpacity="0.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 7.5V16.5"
        stroke="#130F40"
        strokeOpacity="0.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  MinusIcon: ({ className }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M12 0C5.38338 0 0 5.38338 0 12C0 18.6166 5.38338 24 12 24C18.6166 24 24 18.6166 24 12C24 5.38338 18.6166 0 12 0ZM12 1.84615C17.6188 1.84615 22.1538 6.38123 22.1538 12C22.1538 17.6188 17.6188 22.1538 12 22.1538C6.38123 22.1538 1.84615 17.6188 1.84615 12C1.84615 6.38123 6.38123 1.84615 12 1.84615ZM6.46154 11.0769V12.9231H17.5385V11.0769H6.46154Z"
        fill="black"
      />
    </svg>
  ),
};

export const get_started_constants = {
  title: "Get Started Today",
  description:
    "Power your business with AI solutions built for Africa's unique landscape.",
  features: [
    "Browse Ready-to-Use Models",
    "Request Custom Development",
    "Test and Validate",
    "Deploy with Confidence",
  ],
  image:
    "https://res.cloudinary.com/analytics-intelligence/image/upload/v1755204896/powerdbyai/GST_ftwhkk.png",
  CheckIcon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#EDF8FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9457 8.62169L11.5923 16.6834L9.37568 14.315C8.96734 13.93 8.32568 13.9067 7.85901 14.2334C7.40401 14.5717 7.27568 15.1667 7.55568 15.645L10.1807 19.915C10.4373 20.3117 10.8807 20.5567 11.3823 20.5567C11.8607 20.5567 12.3157 20.3117 12.5723 19.915C12.9923 19.3667 21.0073 9.81169 21.0073 9.81169C22.0573 8.73836 20.7857 7.79336 19.9457 8.61002V8.62169Z"
        fill="#084DC5"
      />
    </svg>
  ),
};
